<template>
  <div class="markdown-body">
    <MagazineArticleParsedArticle :components="parsedArticleComponents" />
  </div>
</template>
<script setup lang="ts">
const { parsedArticleComponents = [] } = defineProps<{
  parsedArticleComponents: any[]
}>()
</script>

<style lang="css">
@import '~/assets/css/typography.css';
</style>
